import React from 'react';

import styles from '../../../../utils/styles';
import { TypographyElements } from '../../../foundation';

import './Duration.scss';

export interface IDuration {
  value: string;
  className?: string;
}

const Duration: React.FC<IDuration> = ({ value, className }) => {
  return (
    <div className={styles('time', className)}>
      <TypographyElements text={value} typographyClass="ty-elements-medium--uppercase" />
    </div>
  );
};

export default Duration;
